<template>
  <div>
    <v-btn small color="success" @click="dedicationNewSaleDialog = true">
      New Sale
    </v-btn>

    <router-link
      target="_blank"
      :to="{
        name: 'DedicationItems',
        query: { openNewItem: true },
      }"
    >
      <v-btn class="ml-2" small dark color="default">
        Add New Item <v-icon class="ml-1" small>mdi-open-in-new</v-icon>
      </v-btn>
    </router-link>

    <div v-if="!dedicationSales.length" class="text-center pa-12">
      <v-icon size="80" color="grey lighten-2">mdi-cart-off</v-icon>
      <div class="title grey--text text--darken-1 mt-4">No Sales Yet</div>
    </div>

    <v-expansion-panel v-else class="expansion-panel-margin mt-3">
      <v-expansion-panel-content
        style="background-color: #e3f2dc;"
        v-for="dedicationSale in sortedDedicationSales"
        :key="dedicationSale.saleID"
      >
        <template v-slot:header>
          <v-layout row align-center>
            <!-- Status Icon -->
            <v-flex xs1>
              <v-icon color="success">
                mdi-domain
              </v-icon>
            </v-flex>

            <!-- Item Name -->
            <v-flex xs3>
              <div class="body-2 font-weight-medium mb-1">
                Item Name:
              </div>
              <div class="body-2">
                {{ dedicationSale.itemName }}
              </div>
            </v-flex>

            <!-- Type -->
            <v-flex xs3>
              <div class="body-2 font-weight-medium mb-1">
                זכות:
              </div>
              <div class="body-2">
                {{ dedicationSale.itemType }}
              </div>
            </v-flex>

            <!-- Price -->
            <v-flex xs3 class="text-xs-right pr-4">
              <div class="body-2 font-weight-medium mb-1">
                Final Price:
              </div>
              <div class="subheading font-weight-bold primary--text">
                {{ dedicationSale.finalPrice | currency }}
              </div>
            </v-flex>
          </v-layout>
        </template>
        <dedication-sale-view
          :initial-data="{
            dedicationSale: dedicationSale,
            buildings: buildings,
          }"
        />
      </v-expansion-panel-content>
    </v-expansion-panel>
    <dedication-new-sale-dialog
      v-model="dedicationNewSaleDialog"
      :initial-data="{ donor: donor }"
      @saved="loadDedicationSales()"
    />
  </div>
</template>
<script>
import DedicationNewSaleDialog from "./DedicationNewSaleDialog.vue";
import DedicationSaleView from "./DedicationSaleView.vue";
export default {
  components: {
    DedicationNewSaleDialog,
    DedicationSaleView,
  },
  props: {
    initialData: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    dedicationSales: [],
    dedicationNewSaleDialog: false,
    buildings: [],
  }),
  computed: {
    donor() {
      return this.initialData.donor || null;
    },
    sortedDedicationSales() {
      return [...this.dedicationSales].sort((a, b) => a.saleID - b.saleID);
    },
    salesCount() {
      return this.dedicationSales.length;
    },
  },
  async created() {
    await this.getBuildings();
    await this.loadDedicationSales();
  },
  methods: {
    async loadDedicationSales() {
      if (!this.$route.params.id) return;
      try {
        const dedicationSales = await this.$http.get(
          `api/dedications/GetDedicationSaleForPersonID?personID=${
            this.$route.params.id
          }`
        );
        this.dedicationSales = dedicationSales;
      } catch (error) {
      } finally {
        this.$emit("dedication-sales", this.sortedDedicationSales);
      }
    },
    async getBuildings() {
      try {
        this.buildings = await this.$http.get(
          `api/dedicationitems/getBuildings`
        );
      } catch (error) {}
    },
  },
  // watch: {
  //   dedicationSales(newVal) {
  //     this.$emit('update-sales-count', newVal.length);
  //   }
  // },
};
</script>
